<mat-toolbar class="app-toolbar app-menu" color="primary">
  <mat-toolbar-row>
    <h1 class="mr-auto">{{ title }}</h1>
    <span class="menu-spacer"></span>

    <div class="d-flex justify-content-center align-items-center">
      <!-- Parent Menu Button: Status -->
      <button
        *ngIf="user.hasAdminPermissions()"
        mat-button
        [matMenuTriggerFor]="statusMenu"
        class="parent-menu"
        [ngClass]="{ highlight: isActiveMenu('/status') || isActiveSubMenu(['/status/dynamic', '/status/static']) }"
        routerLinkActive="active-parent-menu"
        [routerLinkActiveOptions]="{ exact: true }">
        Status
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>

      <!-- Status Menu -->
      <mat-menu #statusMenu="matMenu">
        <button
          mat-menu-item
          [routerLink]="['/status/dynamic']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/status/dynamic']) }">
          Status of dynamic image sets
        </button>
        <button
          mat-menu-item
          [routerLink]="['/status/static']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/status/static']) }">
          Status of static image packs
        </button>
      </mat-menu>

      <!-- Parent Menu Button: Logs -->
      <button
        *ngIf="user.hasAdminPermissions()"
        mat-button
        [routerLink]="['/logs']"
        routerLinkActive="active-menu"
        [ngClass]="{ highlight: isActiveMenu('/logs') }">
        Logs
      </button>

      <!-- Parent Menu Button: Upload -->
      <button
        *ngIf="user.hasAdminPermissions() || user.hasUploadPermissions()"
        mat-button
        [routerLink]="['/upload']"
        routerLinkActive="active-menu"
        [ngClass]="{ highlight: isActiveMenu('/upload') }">
        Upload
      </button>

      <!-- Parent Menu Button: Promote -->
      <button
        *ngIf="user.hasAdminPermissions() || user.hasUploadPermissions()"
        mat-button
        [matMenuTriggerFor]="promoteMenu"
        class="parent-menu"
        [ngClass]="{ highlight: isActiveMenu('/promote') || isActiveSubMenu(['/promote/dynamic', '/promote/static']) }"
        routerLinkActive="active-parent-menu"
        [routerLinkActiveOptions]="{ exact: true }">
        Promote
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>

      <!-- Promote Menu -->
      <mat-menu #promoteMenu="matMenu">
        <button
          mat-menu-item
          [routerLink]="['/promote/dynamic']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/promote/dynamic']) }">
          Promote dynamic image sets
        </button>
        <button
          mat-menu-item
          [routerLink]="['/promote/static']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/promote/static']) }">
          Promote static image packs
        </button>
      </mat-menu>

      <!-- Parent Menu Button: Dynamic -->
      <button
        *ngIf="user.hasTestPermissions()"
        mat-button
        [matMenuTriggerFor]="dynamicMenu"
        class="parent-menu"
        [ngClass]="{ highlight: isActiveMenu('/dynamic') || isActiveSubMenu(['/dynamic/validate', '/dynamic/options', '/dynamic/layers']) }"
        routerLinkActive="active-parent-menu"
        [routerLinkActiveOptions]="{ exact: true }">
        Test Dynamic
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>

      <!-- Dynamic Menu -->
      <mat-menu #dynamicMenu="matMenu">
        <button
          mat-menu-item
          [routerLink]="['/dynamic/validate']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/dynamic/validate']) }">
          Validate completeness
        </button>
        <button
          mat-menu-item
          [routerLink]="['/dynamic/options']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/dynamic/options']) }">
          Test Mapping Rules
        </button>
        <button
          mat-menu-item
          [routerLink]="['/dynamic/layers']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/dynamic/layers']) }">
          Test LCDV Mapping
        </button>
      </mat-menu>
      <!-- Parent Menu Button: Static -->
      <button
        *ngIf="user.hasTestPermissions()"
        mat-button
        [routerLink]="['/static']"
        routerLinkActive="active-menu"
        [ngClass]="{ highlight: isActiveMenu('/static') }">
        Test Static
      </button>

      <!-- Parent Menu Button: Admin -->
      <button
        *ngIf="user.hasAdminPermissions() || user.hasUploadPermissions()"
        mat-button
        [matMenuTriggerFor]="adminMenu"
        class="parent-menu"
        [ngClass]="{
          highlight:
            isActiveMenu('/admin') ||
            isActiveSubMenu([
              '/admin/refresh-caches',
              '/admin/manage-global-configs',
              '/admin/manage-asset-profiles',
              '/admin/file-browser',
              '/admin/manage-image-sets',
              '/admin/batch-summary',
              '/admin/dynamic-image-logs'
            ])
        }"
        routerLinkActive="active-parent-menu"
        [routerLinkActiveOptions]="{ exact: true }">
        Administration
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>

      <!-- Administration Menu -->
      <mat-menu #adminMenu="matMenu">
        <button
          *ngIf="user.hasAdminPermissions()"
          mat-menu-item
          [routerLink]="['/admin/refresh-caches']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/admin/refresh-caches']) }">
          Refresh Caches
        </button>
        <button
          *ngIf="user.hasAdminPermissions()"
          mat-menu-item
          [routerLink]="['/admin/manage-global-configs']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/admin/manage-global-configs']) }">
          Manage Global Configs
        </button>

        <button
          *ngIf="user.hasAdminPermissions()"
          mat-menu-item
          [routerLink]="['/admin/manage-oneLayer-lookupTables']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/admin/manage-oneLayer-lookupTables']) }">
          Manage OneLayer Lookup Tables
        </button>
        <button
          *ngIf="user.hasAdminPermissions()"
          mat-menu-item
          [routerLink]="['/admin/manage-asset-profiles']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/admin/manage-asset-profiles']) }">
          Manage Asset Profiles
        </button>
        <button
          *ngIf="user.hasAdminPermissions()"
          mat-menu-item
          [routerLink]="['/admin/file-browser']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/admin/file-browser']) }">
          File Browser
        </button>
        <button
          *ngIf="user.hasAdminPermissions()"
          mat-menu-item
          [routerLink]="['/admin/manage-image-sets']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/admin/manage-image-sets']) }">
          Manage Image Sets
        </button>
        <button
          *ngIf="user.hasAdminPermissions() || user.hasUploadPermissions()"
          mat-menu-item
          [routerLink]="['/admin/batch-summary']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/admin/batch-summary']) }">
          Batch Summary
        </button>
        <button
          *ngIf="user.hasAdminPermissions()"
          mat-menu-item
          [routerLink]="['/admin/dynamic-image-logs']"
          routerLinkActive="submenu-active"
          [ngClass]="{ 'active-submenu': isActiveSubMenu(['/admin/dynamic-image-logs']) }">
          Dynamic Image Logs
        </button>
      </mat-menu>
    </div>

    <div class="ml-auto">
      <button mat-button [matMenuTriggerFor]="list">
        {{ buildInfo.frontendVersion }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #list>
        <div class="d-flex flex-column">
          <div>
            <span class="grey-font">Frontend version: </span><span>{{ buildInfo.frontendVersion }}</span>
          </div>
          <div>
            <span class="grey-font">Backend version: </span><span>{{ buildInfo.backendVersion }}</span>
          </div>
          <div>
            <span class="grey-font">Backend updated: </span><span>{{ buildInfo.backendTimestamp }}</span>
          </div>
          <div>
            <span class="grey-font">App package version: </span><span>{{ buildInfo.appPackageVersion }}</span>
          </div>
          <div>
            <span class="grey-font">Config package version: </span><span>{{ buildInfo.configPackageVersion }}</span>
          </div>
          <div>
            <span class="grey-font">Deployment time: </span><span>{{ buildInfo.deploymentTime }}</span>
          </div>
        </div>
      </mat-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
